document.addEventListener('DOMContentLoaded', function () {
    const columstrips = document.querySelectorAll('.columstrip');
    let currentIndex = 0;

    function showColumstrip(index) {
        columstrips.forEach((columstrip, i) => {
            if (window.innerWidth <= 1199) { 
                // Apply this only on screens below 1199px
                columstrip.style.display = (i === index) ? "flex" : "none";
            } else {
                // Ensure all are visible on larger screens
                columstrip.style.display = "flex";
                columstrip.style.opacity = "1";
            }
        });
    }

    function nextColumstrip() {
        currentIndex = (currentIndex + 1) % columstrips.length;
        showColumstrip(currentIndex);
    }

    // Initial display on load
    showColumstrip(currentIndex); 

    // Change slide every 3 seconds
    setInterval(nextColumstrip, 3000);

    // Re-evaluate on window resize
    window.addEventListener('resize', function() {
        showColumstrip(currentIndex);
    });
});



// document.addEventListener('DOMContentLoaded', function () {
//     const menuToggle = document.querySelector('.header__icon--menu');
//     const searchBar = document.querySelector('.mobile-search-bar');

//     menuToggle.addEventListener('click', function () {
//         if (searchBar.style.display === 'none' || !searchBar.style.display) {
//             searchBar.style.display = 'flex';
//         } else {
//             searchBar.style.display = 'none';
//         }
//     });
// });

/* ---- Vivid mega-menu thumbnails: load-on-interaction ----
   Thumbnails are deferred in snippets/header-mega-menu.liquid via a
   1x1 placeholder src + data-mmsrc. They swap in on first hover/focus/open
   of a menu, with an idle prefetch fallback so they always resolve. This
   keeps ~45 menu images (~480KB) off every page's initial load. */
(function () {
  function loadScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var ims = scope.querySelectorAll('img.mm-lazy[data-mmsrc]');
    for (var i = 0; i < ims.length; i++) {
      var im = ims[i];
      var u = im.getAttribute('data-mmsrc');
      if (!u) continue;
      im.src = u;
      im.removeAttribute('data-mmsrc');
      im.classList.remove('mm-lazy');
    }
  }
  function nearestMenu(t) {
    return (t && t.closest) ? t.closest('.header__inline-menu li, .header__inline-menu header-menu, .header__inline-menu details') : null;
  }
  function onEnter(e) { var m = nearestMenu(e.target); if (m) loadScope(m); }
  document.addEventListener('mouseover', onEnter, true);
  document.addEventListener('pointerover', onEnter, true);
  document.addEventListener('focusin', onEnter, true);
  document.addEventListener('touchstart', onEnter, true);
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.header__inline-menu')) loadScope(t);
  }, true);
  var fired = false;
  function prefetchAll() { if (fired) return; fired = true; setTimeout(function () { loadScope(document); }, 1000); }
  window.addEventListener('scroll', prefetchAll, { once: true, passive: true });
  window.addEventListener('pointermove', prefetchAll, { once: true, passive: true });
  window.addEventListener('keydown', prefetchAll, { once: true });
  if (document.readyState === 'complete') { setTimeout(prefetchAll, 2500); }
  else { window.addEventListener('load', function () { setTimeout(prefetchAll, 2500); }); }
})();
